var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getCurrentPaymentInvoices)?_c('pricing-total',{staticClass:"payment-detail-total",attrs:{"label":_vm.$t('billing.payment_total', {
    count: _vm.$n(_vm.getCurrentPaymentInvoices.length)
  }),"primary-value":_vm.$t('price_incl_tax', {
    price: _vm.total
  })}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }